/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 事件管理中心
 * @Date: 2021-07-26 11:59:35
 * @LastEditTime: 2021-07-26 12:02:33
 */

// 事件管理
export const EVENTS = {
  ADDAPP: 'ADDAPP', // 新增app
  SAVEPLAN: 'SAVEPLAN' ,// 保存计划
  COUNTRY_BACK:'COUNTRY_BACK' //国家，返回上一层操作
};
